module.exports = __webpack_public_path__ + "static/screenshot-5-892d1822e81635e854bf7973ac73ba29.png";